import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replaceDate' })
export class ReplacePipe implements PipeTransform {

  /**
   *
   */
  constructor(private datePipe: DatePipe) {

  }

  transform(value: Date, searchValue: string, replaceValue: string): string {
    const valid = value?.getTime();
    if (isNaN(valid)) return ''

    if (!value) return '';

    const date = this.datePipe.transform(value, 'mediumDate');
    if (!date) {
      return '';
    }
    return date.replace(searchValue, replaceValue);
  }
}
